import { i18n } from '@lingui/core'
import { I18nProvider } from '@lingui/react'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './index.css'
import { messages as messages_es } from './locales/es/messages'
import useGetInfoBrowser from './Utils/useGetInfoBrowser'

i18n._('es', messages_es)
i18n.activate('es')

const propsApp = useGetInfoBrowser()

ReactDOM.render(
  <I18nProvider i18n={i18n}>
    <App {...propsApp} />
  </I18nProvider>,
  document.getElementById('root')
)
